import { connect } from "react-redux";

import SeoText from "./SeoText";
import React from "react";
import {isEqual} from "../../bl/routeService";

const mapStateToProps = state => ({
  routeRequest: state.routeRequest,
  metrics: state.metrics 
});

function areEqual(prevProps, nextProps) {
  return prevProps.className === nextProps.className &&
      prevProps.from === nextProps.from &&
      prevProps.to === nextProps.to &&
      isEqual(prevProps.through, nextProps.through) &&
      isEqual(prevProps.metrics, nextProps.metrics)
}

export default connect(mapStateToProps)(React.memo(SeoText, areEqual));
